//import { Auth0Client } from '@auth0/auth0-spa-js';
import auth0 from "auth0-js";
import AppConstants from "@mywvglobal-shared/mywv-shared/common/appConstants";
import queryString from "query-string";
import { constants } from "../constants";

function auth0Config(loginModule = {}) {
  const webAuth = new auth0.WebAuth({
    domain: loginModule?.domainName,
    clientID: loginModule?.clientId,
    audience:loginModule?.audience,
  });
  return webAuth;
  // domain="wvnz-uat.au.auth0.com"
  // clientId="SNRinaePQlicVAvCXyH6oStNLcZV9gaD"
  // onRedirectCallback={onRedirectCallback}
  // authorizationParams={{
  //    redirect_uri:"http://localhost:3000/nzlo",
  //    audience:"https://wvnz-uat.au.auth0.com/api/v2/",
  //    scope:"openid profile email",
  //    responseType:"token"
  //   //  cacheLocation:"localstorage"
  // }}

}
// eslint-disable-next-line import/prefer-default-export
export async function ExecuteSignIn(loginModule = {}) {
  try {
    if (loginModule?.provider === AppConstants.Auth0) {
      const authState = await auth0Config(loginModule)
        .authorize({
          issuer: loginModule?.domainName,
          responseType: "code",
          // scope: loginModule?.scope,
          scope: "openid params profile email offline_access",
          // client_id : loginModule?.clientId,
          authority : loginModule?.domainName+"/",
          // audience: "https://api.experienceportal.worldvision.org.nz/",
          // resource:"https://wvnz-dev.au.auth0.com/api/v2/",
          redirectUri: constants.currentOrigin ? constants.currentOrigin : constants.postLogoutUrl,
          state : "04b077a9-52d6-4c04-8079-b741612eb5da",
          prompt: loginModule?.prompt ? loginModule?.prompt : "",
          code_challenge_method:"S256",
          code_challenge:"5FKCH59Z5Y9JjVk0CyNRfeo0dAiKp-srK8sJ0Cq3uXk"
        });
        // auth0Config.crossOriginVerification();
        
        return {authState};
        
    } if (loginModule?.provider === AppConstants.OneLogin) {
      const redirect_uri = constants.currentOrigin ? constants.currentOrigin : constants.postLogoutUrl;
      const scope = loginModule?.scope;
     
      const authority = loginModule?.domainName+"/"; //Austria
      const client_id = loginModule?.clientId  //Austria
      const resource = loginModule?.audience; //France

      const response_type = "code";
      const state = "04b077a9-52d6-4c04-8079-b741612eb5da";
      const nonce = "69f4729b-a314-47bf-86a1-23b3e3c7b063";
      const code_challenge_method="S256";
      const code_challenge="5FKCH59Z5Y9JjVk0CyNRfeo0dAiKp-srK8sJ0Cq3uXk";

      // const grant_type =  "refresh_token";
      const params = queryString.stringify({
        scope,
        client_id,
        redirect_uri,
        response_type,
        state,
        nonce,
        resource,
        code_challenge_method,
        code_challenge
      });
      const authUrl = `${authority}auth?${params}`;
      const authState = {
        issuer: loginModule?.domainName,
        clientId: loginModule?.clientId,
        redirectUrl: redirect_uri,
        additionalParameters: {
        resource: loginModule?.audience,
          prompt: "login",
        },
        scopes: ["openid", "profile", "params"],
        connectionTimeoutSeconds: 5,
      }
      const callback = ()=>{
        window.location.assign(authUrl)
       }
      
      return {authState,callback};
    }
  } 
  // TODO : Error should be handled through DB logs or analytics
  catch (error) {
    // Error intentionally ignored. See TODO above.
  }

  return null;
}



// export async function ExecuteSignOut(loginModule = {}, saveAuthParams = {}) {
//   if (loginModule?.provider === AppConstants.Auth0) {
//     const logoutValue = await auth0Config(loginModule).webAuth.clearSession({});
//     return logoutValue;
//   } if (loginModule?.provider === AppConstants.OneLogin) {
//     try {
//       const logoutValue = await logout({
//         ...oneLoginConfig(loginModule),
//         iosPrefersEphemeralSession: true,
//       }, {
//         idToken: saveAuthParams?.idToken,
//         postLogoutRedirectUrl: loginModule?.redirect_url_domain_name
//       });
//       return logoutValue;
//     } catch (error) {
//       return null;
//     }
//   }
// }
